export const DecreaseArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M11.9166 9.20829L7.31242 4.60413L4.60409 7.31246L1.08325 3.79163"
        stroke="#EE3436"
        strokeWidth="1.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66675 9.20837H11.9167V5.95837"
        stroke="#EE3436"
        strokeWidth="1.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IncreaseArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M11.9166 3.79171L7.31242 8.39587L4.60409 5.68754L1.08325 9.20837"
        stroke="#007A4D"
        strokeWidth="1.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66675 3.79163H11.9167V7.04163"
        stroke="#007A4D"
        strokeWidth="1.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
